import type { CSSProperties } from 'react';
import styles from './Skeleton.module.css';

function Base({ className = '', style }: { className?: string; style?: CSSProperties }) {
  return <div className={`${styles.skeleton} ${className}`} style={style} />;
}

export function SkeletonStatCard() {
  return (
    <div className={styles.statCard}>
      <Base className={styles.statCardLabel} />
      <Base className={styles.statCardValue} />
    </div>
  );
}

export function SkeletonItemCard() {
  return (
    <div className={styles.itemCard}>
      <Base className={styles.itemCardImage} />
      <div className={styles.itemCardBody}>
        <Base className={styles.itemCardName} />
        <Base className={styles.itemCardMeta} />
        <Base className={styles.itemCardMeta} style={{ width: '35%' }} />
      </div>
    </div>
  );
}

export function SkeletonAlertRow() {
  return <Base className={styles.alertRow} />;
}
